module.exports = __webpack_public_path__ + "static/media/default_nearme.95c77ade.svg";